export const formatCurrencyBRL = (value: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    value,
  );
export const formatDateBR = (value: string | Date) =>
  new Intl.DateTimeFormat("pt-BR").format(
    typeof value === "string"
      ? new Date(`${value.slice(0, 10)}T12:00:00`)
      : value,
  );
export const formatPercent = (value: number) =>
  new Intl.NumberFormat("pt-BR", {
    style: "percent",
    maximumFractionDigits: 1,
  }).format(value / 100);
export const formatPhoneBR = (value: string) =>
  value.replace(/\D/g, "").replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
